import { Controller } from 'stimulus';
// import { delegate } from 'ez-styles/assets/javascripts/ez-styles/utils/helpers';
import SSTKAPI from '../../shutterstock-api';
import sendSSTKClickEvent from '../../shutterstock-analytics-listener';

export default class SSTKSponsoredSimilarController extends Controller {
  static targets = [
    'apiResultsWrapper',
  ];

  connect() {
    this.searchTerm = this.apiResultsWrapperTarget.getAttribute('data-keyword');
    this.resourceID = this.apiResultsWrapperTarget.getAttribute('data-resource-id');
    this.sstkSharedId = this.element.getAttribute('data-sstk-sharedid');
    this.sstkSubId1 = this.element.getAttribute('data-subid-one');

    this.element.addEventListener('click', sendSSTKClickEvent, { once: false });

    this.getSSTKResults();

    // TODO: Set up tracking here
    // delegate(document, 'click', '[data-target="sstk-sponsored-similar.apiResultsWrapper"] li a', () => {
    //   track('similar_click', this.searchTerm, 'shutterstock');
    // });
  }

  disconnect() {
    this.element.removeEventListener('click', sendSSTKClickEvent, { once: false });
  }

  getSSTKResults() {
    const sstk = new SSTKAPI(this.apiResultsWrapperTarget, this.searchTerm);

    sstk.getResults({
      controllerElem: this.element,
      affiliate: this.apiResultsWrapperTarget.getAttribute('data-affiliate'),
      ird: this.apiResultsWrapperTarget.getAttribute('data-ird'),
      loc: this.apiResultsWrapperTarget.getAttribute('data-loc'),
      limit: this.apiResultsWrapperTarget.getAttribute('data-limit'),
      apiparams: this.apiResultsWrapperTarget.getAttribute('data-apiparams'),
      rowHeight: parseInt(this.apiResultsWrapperTarget.getAttribute('data-row-height'), 10),
      maxRows: this.apiResultsWrapperTarget.getAttribute('data-max-rows'),
      largeThumb: true,
      urlparams: sstk.makeUrlParams(this.sstkSharedId, this.sstkSubId1, this.resourceID),
    });
  }
}
